
export default function ReportsReducer(state = {}, action) {
    switch (action.type) {
        case 'FILTERED_REPORTS_LIST':
            return Object.assign({}, state, {
                ReportList: action.data
            });
        default:
            return state
    }
};



// WEBPACK FOOTER //
// ./src/modules/reports/reducer.js